import Head from "next/head";
import Header from "../components/Header";

export default function CGUPage(){
  return (
    <div className='w-full min-h-screen bg-blue flex flex-col relative overflow-x-hidden text-white' >
      <Head>
        <title>Metabella - CGU</title>
        <meta name="description" content="Abella Danger nft collection" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div className='background'></div>
      <Header
        
      />
      <main className='z-30 bg-gradient-to-b from-transparent to-purple'>
      <div className="w-full">
      <div className="text-center w-full max-w-screen-md mx-auto">
        INNOVATIVE CLOUD TECH - THE POKEN COMPANY<br/>
        - simplified joint-stock company with a share capital of EUR 215.055,00 -<br/>
        RCS Paris, France, No. B 899 756 340<br/>
        Registered office: 14 rue du Printemps 75017 PARIS - FRANCE<br/>
        <br/><br/>
        <h1 className="text-3xl">
        METABELLA<br/>
        TERMS AND CONDITIONS
        </h1>

        <br/><br/>
      </div>
      <div className="w-full max-w-screen-md mx-auto">
        PREAMBLE<br/><br/>

        INNOVATIVE CLOUD TECH d/b/a acting under the commercial name of “The Poken Company” (hereinafter “TPC”) operates the POKMI platform of non-fungible token dedicated to adult entertainment.<br/>
        TPC launches a collection of 1158 non fungible token representing the creator, Abella Danger (hereinafter the “NFT”), and accessible under the following link https://metabella.pokmi.com/ (hereinafter the “Platform“). 
        <br/><br/>

        SECTION 1. DEFINITIONS <br/><br/>

        Capitalized terms and expressions, whether used in the singular or plural, shall have the meaning given to them below:<br/>

        “Certificate” means a digital certificate of authenticity issued at the time of the Transaction, implemented into the smart contract of the corresponding NFT and providing in particular for the assignment of intellectual property rights to the Purchaser as well as the conditions of transfer of the NFT and its Certificate by the Purchaser to a subsequent purchaser;<br/>

        “Content” means any content, data, information, video, image, recording, comment, message, document or other content of any kind whatsoever, published, uploaded, posted, sent, shared or communicated by TPC on the Platform. Once the Content is purchased by a Purchaser, the Content is Minted and linked to a NFT by TPC granting rights on the said NFT to the Purchaser;<br/>

        “Intellectual Property Right” means any registered or unregistered right, including but not limited to patents, patent applications, trademarks, trademark applications, designs, copyrights and related rights;<br/>

        “Metamask Wallet” means the User&apos;s wallet that allows the User to access its Ethereum crypto-currency and from which the User can carry out Transactions. The User must have a Metamask Wallet in order to purchase NFT;<br/>
        
        “Metaverse” means a virtual-reality space owned by TPC in which users can interact with a computer-generated environment and other users ; 

        “Mint” means registering a data token on a public blockchain so that it becomes immutable, tradable but also searchable and verifiable by anyone ; 

        “Non-Fungible Token” or “NFT” means a non-fungible digital token saved in a Smart Contract and linked to a Content, representing one or more rights ; 

        “Personal Data” means any information relating to an identified or identifiable natural person (hereinafter referred to as “Data Subject”); an “identifiable natural person” is deemed to be a natural person who can be identified, directly or indirectly, in particular by reference to an identifier such as a name, an identification number, location data, an online identifier or to one or more factors specific to the physical, physiological, genetic, mental, economic, cultural or social identity of that natural person.<br/>

        “Personality Attributes” means any image, voice, name, surname, username of any performer of a Content such as Abella Danger ;<br/>

        “Platform” means the platform operated by TPC and accessible under the following address https://metabella.pokmi.com/;<br/>

        “POKEN” or “PKN” means the crypto-currency developed by TPC and used on its POKMI platform. The usage of PKN on the POKMI platform requires the User to create an account on that platform. Representing a value used as a means of exchange to benefit from the POKMI platform, PKNs are digital assets within the meaning of Article L54-101 2° of the French Monetary and Financial Code and do not constitute financial instruments within the meaning of Article L. 211-1 of the same code.<br/>

        “Purchaser” means any User who purchases NFT on the Platform; 

        “Purchase Offer” and “Sale Offer” means a firm proposal to buy or sell NFT made on the Platform;<br/>

        “Smart Contract” means a computer program registered in the blockchain that allows a Transaction to be executed automatically;<br/>

        “Terms and Conditions” or “Terms” means this document;<br/>

        “Transaction” means the purchase of NFTs on the Platform. The Transaction is only effective once payment with Ethereum has been received by TPC;<br/>

        “User” means any user of the Platform;<br/>

        “Wearable”: means a data representing digital clothes and accessories proposed for sale and to be used on the Metaverse. Wearable are Contents.<br/><br/>


        SECTION 2. PURPOSE<br/><br/>

        The purpose of these Terms is to define the conditions of use of the Platform as well as the relationship between TPC and the Users.<br/>

        The Platform proposes NFTs for sale to Users under certain conditions defined hereinafter. <br/><br/>


        SECTION 3. ACCEPTANCE<br/><br/>
        3.1 Access to or use of the Platform implies full acceptance and compliance with the Terms. 

        The Content posted on the Platform is of an erotic and/or pornographic nature and is likely to offend or harm the sensitivity of young people. 

        The Users hereby declare and warrant that they are at least eighteen (18) years of age and that they are using the Platform for personal use, and not for any professional purpose. The Users declare that they have full legal capacity and rights to carry out Transactions on the Platform.<br/>

        3.2 TPC reserves the right to modify the Terms and posting any future modification on the Platform at least five (5) days before the date on which the modifications come into effect. Users will then be free to accept or refuse these new modifications. In the latter case, the User must stop using the Platform. 
        <br/><br/>

        SECTION 4. PRE-CONTRACTUAL INFORMATION<br/><br/>

        4.1 The User acknowledges that prior to purchasing NFT in any manner whatsoever, they have read and understood the Terms all the information specified in article L221-5 of the French Consumer Code.<br/>

        Accordingly, the following information is provided to the User in a clear and understandable manner:<br/>
        -	the essential features of NFTs; 
        -	the price of the NFTs and the related fees, in particular the gas fees of the Ethereum Blockchain;<br/>
        -	information relating to the identity of TPC, its postal address, email address and telephone number and its activities;<br/>
        -	information regarding the legal guarantees, the features of the digital content and, where applicable, its interoperability, the existence and the terms of implementation of guarantees and other contractual conditions.<br/>

        4.2 TPC shall provide the User with the following information:<br/>
        -	its name or corporate name, the geographical address of its place of business and, if different, that of its registered office, its telephone number and its email address as they appear in particular in its Legal Notice;<br/>
        -	the terms of payment, delivery and execution of the Transactions, as well as the terms provided by TPC for the handling of complaints;<br/>
        -	in the event of a sale, the existence and conditions of exercise of the legal guarantee of conformity provided for in Articles L. 217-1 et seq. of the French Consumer Code, the guarantee against hidden defects provided for in Articles 1641 et seq. of the French Civil Code, as well as, where applicable, the commercial guarantee and after-sales service referred to in Articles L. 217-15 and L. 217-17 of the French Consumer Code;<br/>

        4.3 With respect to digital content, TPC shall indicate:<br/>
        -	any relevant interoperability of this content with specific hardware or software of which TPC has or should reasonably be aware.<br/>
        <br/><br/>

        SECTION 5. CONTENT, ACCESS, CONDITIONS FOR PURCHASE <br/><br/>

        5.1 Content of NFTs<br/>

        The Content of the NFT is:<br/>
        a representation of Abella Danger, to which a Certificate is attached,<br/>
        a right to purchase upcoming Wearables on TPC’s Metaverse, still to be defined by TPC<br/>
        an access to upcoming private clubs in TPC’s Metaverse, still to be defined by TPC,<br/>
        any other rewards to be defined by TPC.<br/>

        5.2 Conditions of access 
        1158 NFTs are proposed for sale on the Platform under the following conditions:<br/>

        200 NFTs will be used for marketing and communication purposes by TPC at its sole convenience.<br/>
        696 Users will be drawn at random to constitute the Whitelist based on:<br/>
        giveaways, ie specific access to the Whitelist (like gift) provided through social networks,<br/>
        tasks achievement by Users on Discord (such as referral),<br/>

        Whitelist Users will get the possibility to purchase up to 3 NFTs at a price of 0,08 ETH/NFT (hereinafter “Private Sale”).<br/>

        Start and duration of the Private Sale will be communicated on TPC social and communication networks.<br/>

        Following the Private Sale, remaining NFTs will be proposed for sale to a Public Sale where Users may purchase up to 4 NFTs at a price of 0,1 ETH/NFT.<br/>

        <br/>
        5.3 Conditions for Purchase<br/>

        Purchase of NFT requires the Users to have a Metamask Wallet with sufficient ETH and to connect on the Platform. 
        Upon receipt of the ETHs in exchange for the NFT, the said NFT will be automatically transferred to the Purchaser&apos;s Metamask Wallet. 

        The Mint occurs simultaneously with the Transaction. Users may sell their NFTs on secondary markets following the Transactions.<br/>

        The User acknowledges and accepts that due to the digital nature of the Services, the right of withdrawal provided for in article L221-18 and following of the French Consumer Code is not applicable.<br/>

        Two (2) to ten (10)  days after the Public Sale is over, the Content of the NFTs will be revealed to their Purchasers.<br/>

        <br/>
        SECTION 6. RIGHTS ON THE NFT AND ON THE CONTENT<br/><br/>

        6.1 Rights granted to Purchasers on the NFT 
        Upon completion of the Transaction, the NFT Purchaser obtains a Certificate for the Content to which the NFT is linked (see below 6.2). As a result, the NFT Purchaser may access, view and/or use the Content. The Purchaser may also, subject to compliance with the resale right granted to TPC, which creates a right for the TPC/Creator to receive royalties from the Purchaser and then from each subsequent purchaser each time the NFT is resold, transfer or resell the NFT to a third party, on any platform applying the EIP 2981 standard. 



        6.2 Rights granted to Purchasers on the Content 
        The Content linked to the NFT may be subject to Intellectual Property Rights or Personality Attribute Rights. 
        Once the Transaction is completed,  Intellectual Property Rights are granted by TPC to the Purchaser by means of a Certificate implemented into the Smart Contract. 

        Such Certificate is available on the metadatas attached to the NFT. This Certificate provides, in particular, the terms and conditions under which Intellectual Property Rights are granted to the Purchaser, as well as the terms and conditions under which said Certificate will be transferred, along with the corresponding NFT, by the Purchaser to any subsequent purchaser.  
        
        Unless otherwise provided in the Smart Contract of a NFT, TPC grants to Purchasers a license to: 

        use, reproduce, display, sell or otherwise use the Content linked to a NFT  on any medium and by any means, on a worldwide basis and for the entire legal duration of intellectual property rights, in application of both French and foreign legislation and current or future laws and regulations, including any extensions that may be made to this duration, to the exclusion of any exploitation rights pertaining to the Content to which the NFT is linked for commercial purposes.<br/>

        Notwithstanding the provisions set forth in the Certificate, the Purchaser acknowledges and accepts that TPC may continue to use, reproduce, display, modify and adapt the Content for the purposes of promoting the Platform and, more broadly, the services offered by POKMI, even once the NFT has been purchased by the Purchaser.<br/>

        6.3 Guarantees relating to the Content<br/>

        TPC declares and warrants that it: 

        i. holds all Intellectual Property Rights pertaining to the Content and the Personality Attributes; 

        ii. has completed all necessary formalities and, where applicable, obtained all necessary authorizations to be able to upload the Content, mint it, make it available for sale and sell it on the Platform;<br/>

        iii. has full power and capacity to reproduce and display the Content on the Platform as well as to mint the Content; 

        iv. has not introduced into the Content any element likely to prevent or interfere with the enjoyment of the Content by the Purchaser or sub-Purchasers. 

        TPC is liable to the Purchasers or third parties in the event of non-compliance with this obligation and shall hold Purchasers harmless against any claim of any nature whatsoever relating to the Content, in particular against any claim of any kind whatsoever, for infringement of intellectual property rights, for violation of a right to one&apos;s image or, more generally, against any action relating to an infringement of a third party&apos;s right. <br/><br/>




        SECTION 7. RIGHTS AND OBLIGATIONS OF TPC<br/><br/>

        TPC shall ensure that the Platform is made available to Users in accordance with the Terms. However, TPC cannot exclude possible errors and malfunctions of the Platform which it shall fix as soon as possible.<br/>

        The User acknowledges and accepts that TPC may be required to respond to a court order or requests for information from competent judicial or government authorities and, in this respect, may disclose information relating to the Users and the Transactions.<br/>

        TPC may, at any time, create new services and/or special offers, as well as contests, games or promotions to promote third-party goods or services. Specific conditions relating to offers, competitions, games or promotions shall be provided on the Platform. 
        TPC may at any time terminate or suspend or assign to third parties the operation of the Platform, subject to notifying the Users thereof, giving thirty (30) days&apos; notice. <br/><br/>
        

        SECTION 8. LIABILITY<br/><br/>

        TPC is subject to an obligation of means to make the Platform available.<br/>

        TPC shall only be liable in the event of proven fault or negligence and shall be limited to direct damages to the exclusion of any indirect damages of any kind (such as loss of profit, loss of opportunity, expected benefits, reputational damage). 
        Furthermore, TPC shall not be held liable in the following cases:<br/>
        interruptions, disruptions, modifications and malfunctions of the Platform whatever the communication medium used and whatever the origin and source;<br/>
        the loss of data or information stored by the Platform; 
        Platform temporarily unavailable due to technical problems, regardless of their origin or source;<br/>
        direct or indirect damage caused to the User, whatever its nature, resulting from access, management, use, operation, malfunction and/or interruption of the Platform; 
        abnormal or illicit use of the Platform by any User; 
        computer attack or hacking, temporary or permanent loss or restriction, for whatever reason, of access to the Internet network.<br/>

        Each User is solely responsible for any damage caused as a result of the use of the Platform and/or the execution of a Transaction and its consequences or, more generally, to any third party as a result of the use of the Platform and the consequences of any claims or actions that may arise therefrom. <br/><br/>


        SECTION 9. TPC&apos;S INTELLECTUAL PROPERTY ON THE PLATFORM<br/><br/>

        TPC holds all the rights, titles and interests relating to the Site and the Platform and in particular the intellectual property rights (in particular on the layout and design of the Platform, on the software used by and for the Platform, on the brands and domain names used in connection with the Platform, etc.).<br/>
        The Terms do not give the User any intellectual property rights over the Platform as well as over the trademarks, original creations and other elements of TPC likely to be protected by intellectual property rights, which remain the full and exclusive property of TPC. 
        Consequently, the User shall not reproduce permanently or temporarily the Platform in whole or in part, or any element derived therefrom, by any means and in any form, including when loading, displaying or performing the Platform. 
        The User shall not translate, adapt, arrange or modify the Platform, export them or merge them with others.<br/>

        TPC has no control over the content of third-party sites. The existence of a hypertext link between the Platform and a third-party site in no way signifies control of the content of the third-party site by TPC.<br/>

        Each User of the Platform shall take all appropriate measures to prevent their own data and/or software from being infected by any viruses circulating on the Internet. In this respect, the Users of the Platform shall not damage the Platform or misuse it by intentionally introducing viruses, Trojan horses, worms, logic bombs and other malicious or technologically harmful devices.<br/>
        <br/>

        SECTION 10. PROCESSING OF PERSONAL DATA<br/><br/>

        In accordance with Regulation 2016/679 of 27 April 2016 on the protection of individuals with regard to the processing of personal data and on the free movement of such data, the rights and obligations of Users and TPC with regard to the protection of personal data are defined in the Privacy Policy of the Platform.<br/>
        <br/>

        SECTION 11. GOVERNING LAW - AMICABLE SETTLEMENT <br/><br/>

        The Terms shall be governed by, construed and enforced in accordance with the laws of France. In the event of a dispute arising in connection with the performance, termination or interpretation of the Terms, the parties shall strive to settle their dispute amicably. In such case, the User shall send their complaint to the following e-mail address: support@thepokencompany.com for Users. The User also has the right to request the resolution of his dispute through the dedicated platform accessible via the following e-mail address: 
        http://ec.europa.eu/consumers/odr/. 

        If the parties fail to reach an amicable agreement, the User may refer the matter free of charge to the consumer mediator, i.e., the Association des Médiateurs Européens (AME CONSO), within a period of one year from the date of receipt of the written complaint.<br/>
        The referral to the consumer mediator must be made:<br/>

        either by filling in the form provided for this purpose on the AME CONSO website: www.mediationconso-ame.com ;<br/>
        or by mail addressed to AME CONSO, 11 Place Dauphine - 75001 PARIS. 



        <br/><br/>

        SECTION 12. MISCELLANEOUS <br/><br/>

        By using this Site, the User accepts that communication with TPC will be carried out mainly by electronic means and in particular by e-mail or by posting notices on the Platform.<br/>

        TPC reserves the right to assign, subcontract or transfer all or part of the Terms.<br/>

        A party&apos;s failure to assert any right or provision under the Terms shall not constitute a waiver of such right or provision.<br/>

        If any provision of the Terms is held to be invalid or declared as such in application of a law, a regulation or following a final decision of a competent jurisdiction, this will not affect the validity or enforceability of any remaining provision.<br/>


        Updated: 21st of February 2022<br/>
      </div>








    </div>
      </main>
    </div>
    
  )
}